<template>
  <div class="home" v-title.async="title">
    <!-- <div class="search-wrap-bg">
      <div class="search-wrap">
        <div class="search-input-wrap">
          <input id="search-input" class="search-input" type="text">
        </div>
      </div>
    </div>-->

    <div class="big-tags-wrap tags-bg-color" v-if="showTab">
      <div
        :class="t.id == acType ? 'on' : ''"
        v-for="t in type"
        :key="t.id"
        @click="toType(t.id)"
      >{{t.name}}</div>
    </div>
    <div class="banner-wrap" v-if="banners.length > 0">
      <swipe :key="`v-banner${acType}`" :auto="50000" :loop="true" v-if="banners.length > 1">
        <a :href="banner.t_url" v-for="(banner, index) in banners" :key="index">
          <img :src="banner.url" class="swipe-img">
        </a>
      </swipe>
      <a :href="banners[0] && banners[0].t_url" v-else>
        <img :src="banners[0] && banners[0].url" class="swipe-img">
      </a>
    </div>

    <div
      class="small-tags-wrap tx-border-line-bot"
      v-sticky
    >
      <div class="small-tag-scroll">
        <div
          class="small-tag"
          originalWidth="186"
          :class="actCategory == '-1' ? 'on' : ''"
          @click="tabClick('-1')"
        >
          <span>全部</span>
        </div>
        <div
          class="small-tag"
          originalWidth="186"
          v-for="category in categories"
          :key="category.id"
          :class="category.id == actCategory ? 'on' : ''"
          @click="tabClick(category.id)"
        >
          <span>{{category.name}}</span>
        </div>
      </div>
    </div>
    <div
      :infinite-scroll-disabled="!pager.hasNext"
      v-infinite-scroll="loadMore"
      infinite-scroll-distance="100"
      infinite-scroll-immediate-check="bCheck"
      class="content-box"
    >
      <ul class="content">
        <li v-for="(info, index) in infoList" :key="index" @click="goDetail(info.id)" class="list">
          <div class="news-text" v-if="info.type === 1">
            <div class="news-text-content clear">
              <div class="text">
                <p class="title tx-word-line line-3">{{info.title}}</p>
                <div class="tag-wrap clear">
                  <span class="tag" v-for="(t, index) in tag(info.tag)" :key="index">{{t}}</span>
                </div>
              </div>

              <div class="logo-img">
                <img v-lazy="info.c_url" :src="info.c_url" alt>
              </div>
            </div>
            <div class="information clear">
              <div class="date">{{info.p_date}}</div>
              <div class="views" v-if="info.pv">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconchakan"></use>
                </svg>
                {{info.pv}}
              </div>
              <div class="comment" v-if="listMap[info.id] && listMap[info.id].num">
                <span class="comment-icon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#iconpinglun"></use>
                  </svg>
                </span>
                {{listMap[info.id] && listMap[info.id].num}}
              </div>
            </div>
          </div>

          <div class="news-video" v-if="info.type === 2">
            <div class="video-wrap">
              <div class="video-bg">
                <img v-lazy="info.c_url" :src="info.c_url" alt>
              </div>
              <div class="video-play">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconbofang1"></use>
                </svg>
              </div>
              <div class="date">{{info.p_date}}</div>

              <div class="views" v-if="info.pv">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconchakan"></use>
                </svg>
                {{info.pv}}
              </div>
            </div>
            <p class="title tx-word-line line-2">{{info.title}}</p>
            <div class="information clear">
              <div class="tag-wrap clear">
                <span class="tag" v-for="(t, index) in tag(info.tag)" :key="index">{{t}}</span>
              </div>
              <div class="comment" v-if="listMap[info.id] && listMap[info.id].num">
                <span class="comment-icon">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#iconpinglun"></use>
                  </svg>
                </span>
                {{listMap[info.id] && listMap[info.id].num}}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="listBottom" v-if="!pager.isEmpty">
        <img src="~assets/img/loading.png" alt class="rotate360" v-if="pager.isLoading">
        {{pager.hasNext ? '正在加载...' : '已经到底啦'}}
      </div>
    </div>
    <div class="empty" v-if="pager.isEmpty">
      <div class="txt">内容更新中</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import fetchJsonp from 'fetch-jsonp'
import api from '@/api'
import Swipe from '@/components/Swipe/index.vue'

export default {
  name: 'Index',
  data() {
    return {
      title: '',
      bannerList: [],
      banners: [],
      categories: [],
      site: this.$route.query.site,
      type: [
        {
          id: 0,
          name: '推荐',
        },
        {
          id: 1,
          name: '攻略',
        },
        {
          id: 2,
          name: '视频',
        },
      ],
      acType: this.$route.query.type || 0,
      actCategory: this.$store.state.category,
      infoList: [],
      pager: null,
      topBase: 0,
      bCheck: false, // iscroll首屏禁止自动加载
      listMap: {},
      showTab: true,
    }
  },
  watch: {
    acType() {
      this.pager = this.initPager()
      this.queryInfo()
    },
  },
  components: {
    Swipe,
  },
  created() {
    if (!this.site) {
      alert('未选择游戏')
      return
    }
    this.pager = this.initPager()
    if (this.$store.state.bMemory) {
      this.$store.commit('setMemory', false)
      const {
        infoList, hasNext, curPage, bannerList, categories, scrollTo, listMap,
      } = this.$store.state.dataList
      this.infoList = [...infoList]
      this.categories = categories
      this.bannerList = bannerList
      this.pager.hasNext = hasNext
      this.pager.curPage = curPage
      this.listMap = listMap
      this.handleBanner()
      window.setTimeout(() => {
        window.scrollTo(0, scrollTo)
      }, 5)
    } else {
      api
        .config(this.site, {
          s: new Date().getTime(),
        })
        .then((res) => {
          this.categories = res.categories
          this.bannerList = res.banners
          this.showTab = !res.hidden_tab
          this.handleBanner()
          this.wxConfig(res.icon)
        })
      this.loadMore()
    }
  },
  mounted() {
    this.title = '攻略站'
    this.$nextTick(() => {
      this.topBase = document.getElementsByClassName('small-tags-wrap')[0].offsetTop
    })
  },
  methods: {
    handleBanner() {
      this.banners = this.bannerList[this.acType].filter(banner => this.compareDate(banner.st, banner.et))
    },
    compareDate(dateStart, dateEnd) {
      const dateNow = new Date().getTime()
      const date1 = new Date(dateStart.replace(/-/g, '/'))
      const date2 = new Date(dateEnd.replace(/-/g, '/'))
      if (date1.getTime() < dateNow && dateNow < date2.getTime()) {
        return true
      }
      return false
    },
    getCommentNum(list) {
      const that = this
      let objlist = ''
      for (let i = 0; i < list.length; i += 1) {
        objlist += `all_mobile,${list[i].p_date.split('-', 2).join('')},${list[i].id}${process.env.NODE_ENV}_gzh_news;`
      }
      fetchJsonp(`https://app.ingame.qq.com/php/ingame/comment/query_source_list_info.php?gameid=gzh_news&objlist=${objlist}`)
        .then(response => response.json())
        .then((json) => {
          that.commentNum(json.data.stat_list)
        })
        .catch((ex) => {
          console.log('parsing failed', ex)
        })
    },
    commentNum(list) {
      const map = {}
      for (let i = 0, l = list.length; i < l; i += 1) {
        map[parseInt(list[i].objid, 10)] = list[i]
      }
      this.listMap = { ...this.listMap, ...map }
    },
    toType(typeId) {
      this.acType = typeId
      this.handleBanner()
      this.$router.push({ path: `/?type=${this.acType}&site=${this.site}` })
    },
    goDetail(id) {
      const dataList = {
        infoList: this.infoList,
        curPage: this.pager.curPage,
        hasNext: this.pager.hasNext,
        scrollTo: document.body.scrollTop + document.documentElement.scrollTop,
        bannerList: this.bannerList,
        categories: this.categories,
        listMap: this.listMap,
      }
      this.$store.commit('setDataList', dataList)
      this.$store.commit('setMemory', true)
      this.$router.push({ path: `detail/${id}` })
    },
    tag(tags) {
      return tags.split(',').slice(0, 2)
    },
    initPager() {
      return {
        curPage: 1,
        isLoading: false,
        hasNext: true,
        isEmpty: false,
      }
    },
    tabClick(categoryId) {
      if (this.actCategory !== categoryId) {
        this.actCategory = categoryId
        this.$store.commit('setCategory', categoryId)
        if (document.body.scrollTop + document.documentElement.scrollTop > this.topBase) {
          window.scrollTo(0, this.topBase)
        }
        this.pager = this.initPager()
        this.queryInfo()
      }
    },
    loadMore() {
      this.queryInfo()
    },
    queryInfo() {
      const caid = this.actCategory === '-1' ? null : this.actCategory
      const { pager } = this
      // bMemory是为了标志是从文章回退，由于iscroll bug 还会发送请求。故return
      if (!pager.hasNext || pager.isLoading || this.$store.state.bMemory) {
        return
      }
      pager.isLoading = true
      api
        .infoList({
          site: this.site,
          type: this.acType,
          page: pager.curPage,
          caid,
        })
        .then((res) => {
          if (pager.curPage === 1) {
            this.infoList = res.result.list
          } else {
            this.infoList = this.infoList.concat(res.result.list)
          }
          this.getCommentNum(res.result.list)
          pager.hasNext = res.result.has_next
          pager.curPage += 1
          pager.isLoading = false
        })
    },
    wxConfig(icon) {
      // 微信分享配置
      const share = {
        img: `${icon}64`,
        title: '攻略站',
        desc: '最全攻略一网打尽，点击查看',
        href: window.location.href,
      }
      this.$wxShare(share)
    },
  },
}
</script>
<style scoped lang="scss" src="./index.scss"></style>
